import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const Barriers = () => {

    const { patientId } = useParams<{ patientId: string }>();
    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(setPageTitle('Barriers: Patient Profile | Spire360'));
    }, []);

    return (
        <div>
            <div className='px-4 py-3 border rounded-3 shadow-xs'>
                <strong>Transportation</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Transportation01" value="Transportation01" readOnly checked/>
                        <label className="form-check-label" htmlFor="Transportation01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Transportation02" value="Transportation02" disabled/>
                        <label className="form-check-label" htmlFor="Transportation02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Joblessness</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioJoblessness" id="Joblessness01" value="Transportation01" disabled/>
                        <label className="form-check-label" htmlFor="Joblessness01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioJoblessness" id="Joblessness02" value="Joblessness02" readOnly checked/>
                        <label className="form-check-label" htmlFor="Joblessness02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Mental Health Concerns</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioHealth" id="Health01" value="Health01" readOnly checked/>
                        <label className="form-check-label" htmlFor="Health01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioHealth" id="Health02" value="Health02" disabled/>
                        <label className="form-check-label" htmlFor="Health02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Housing instability/Utility needs</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioHousing" id="Housing01" value="Housing01" readOnly checked/>
                        <label className="form-check-label" htmlFor="Housing01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioHousing" id="Housing02" value="Housing02" disabled/>
                        <label className="form-check-label" htmlFor="Housing02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Medication adherence</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioMedication" id="Medication01" value="Medication01" disabled/>
                        <label className="form-check-label" htmlFor="Medication01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioMedication" id="Medication02" value="Medication02" readOnly checked/>
                        <label className="form-check-label" htmlFor="Medication02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Patient activation (patient engagement)</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioactivation" id="activation01" value="activation01" disabled/>
                        <label className="form-check-label" htmlFor="activation01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioactivation" id="activation02" value="activation02" readOnly checked/>
                        <label className="form-check-label" htmlFor="activation02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Food insecurity/access to food</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioFoodInsecurity" id="FoodInsecurity01" value="FoodInsecurity01" disabled/>
                        <label className="form-check-label" htmlFor="FoodInsecurity01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioFoodInsecurity" id="FoodInsecurity02" value="FoodInsecurity02" readOnly checked/>
                        <label className="form-check-label" htmlFor="FoodInsecurity02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Ability to pay for medications and healthcare visits/testing</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioAbility" id="Ability01" value="Ability01" disabled/>
                        <label className="form-check-label" htmlFor="Ability01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioAbility" id="Ability02" value="Ability02" readOnly checked/>
                        <label className="form-check-label" htmlFor="Ability02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Smoking Cessation</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioSmoking" id="Smoking01" value="Smoking01" readOnly checked/>
                        <label className="form-check-label" htmlFor="Smoking01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioSmoking" id="Smoking02" value="Smoking02" disabled/>
                        <label className="form-check-label" htmlFor="Smoking02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Lack of physical activity</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="Radiophysical" id="physical01" value="physical01" disabled/>
                        <label className="form-check-label" htmlFor="physical01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="Radiophysical" id="physical02" value="physical02" readOnly checked/>
                        <label className="form-check-label" htmlFor="physical02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Caregiver Burden</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioCaregiverBurden" id="CaregiverBurden01" value="CaregiverBurden01" disabled/>
                        <label className="form-check-label" htmlFor="CaregiverBurden01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioCaregiverBurden" id="CaregiverBurden02" value="CaregiverBurden02" readOnly checked/>
                        <label className="form-check-label" htmlFor="CaregiverBurden02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Alcohol (Substance) misuse</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioAlcohol" id="Alcohol01" value="Alcohol01" disabled/>
                        <label className="form-check-label" htmlFor="Alcohol01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioAlcohol" id="Alcohol02" value="Alcohol02" readOnly checked/>
                        <label className="form-check-label" htmlFor="Alcohol02">No</label>
                    </div>
                </div>
            </div>
            <div className='px-4 py-3 border rounded-3 mt-3 shadow-xs'>
                <strong>Substance misuse</strong>
                <div className="mt-2">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioSubstance" id="Substance01" value="Substance01" disabled/>
                        <label className="form-check-label" htmlFor="Substance01">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="RadioSubstance" id="Substance02" value="Substance02" readOnly checked/>
                        <label className="form-check-label" htmlFor="Substance02">No</label>
                    </div>
                </div>
            </div>
            <div className='p-4 border rounded-3 mt-3 shadow-xs'>
                <strong>Other Barriers</strong>
                <div className="mt-3">
                    <textarea name="comments" rows={1} placeholder="Other..." className="form-control fs-12 rounded-top-0 mt-3"></textarea>
                </div>
            </div>
        </div>
    )
}